import './Designation.scss';

import { SvgIcon } from '@mui/material';
import ButtonField from '../../Components/Button/ButtonField';
import Table from '../../Components/Table/Table';
import CustomToolbar from '../../Components/Table/components/CustomToolbar';
import TableSearch from '../../Components/Table/components/TableSearch';
import { IDesignationList, DesignationProps } from './IDesignation';
import {
  FunctionComponent,
  MouseEvent,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { ReactComponent as Add } from '../../Assets/Images/Add.svg';
import { Columns } from '../../Components/Table/ITable';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import { getDesignation } from '../../Redux/Slicers/Designation/DesignationSlicer';
import {
  GridActionsCellItem,
  GridRowParams,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import { ReactComponent as Edit } from '../../Assets/Images/Edit.svg';
import { ReactComponent as Delete } from '../../Assets/Images/Delete.svg';
import Dialog from '../../Components/Dialog/Dialog';
import IconButtonField from '../../Components/Button/IconButtonField';
import { ReactComponent as Cancel } from '../../Assets/Images/Cancel.svg';
import DesignationForm from './DesignationForm';
import { FormikProps } from 'formik';
import {
  clearUpdateDesignationState,
  designationUpdateableData,
} from '../../Redux/Slicers/Designation/UpdateDesignationSlicer';
import ResponseDialog from '../../Components/ResponseDialog/ResponseDialog';
import DeleteDialog from '../../Components/DeleteDialog/DeleteDialog';
import {
  clearDeleteDesignation,
  deleteDesignation,
} from '../../Redux/Slicers/Designation/DeleteDesignationSlice';
import { clearAddDesignationState } from '../../Redux/Slicers/Designation/AddDesignationSlicer';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getVehicle } from "../../Redux/Slicers/Vehicle/VehicleSlicer";
import { MembershipVehicleCall } from "../../Redux/Slicers/MembershipVehicle/MembershipVehicleApi";
import { getMembershipVehicle } from "../../Redux/Slicers/MembershipVehicle/MembershipVehicleSlicer";
import Vehicle from "../MembershipVehicle/MembershipVehicle";
import { packageManagementCard } from "../../Redux/Slicers/PackageManagement/PackageManagementCardSlice";

const Designation: FunctionComponent<DesignationProps> = () => {
  const dispatch = useAppDispatch();
  const { id }: any = useParams();
  const { data } = useAppSelector((state) => state.Designation);
  const [open, setOpen] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteableName, setDeleteableName] = useState<string>("");
  const [deleteableId, setDeleteableId] = useState<number>(0);
  const [formik, setFormik] = useState<FormikProps<IDesignationList>>();
  const { data: updateDesignation, updateableDate } = useAppSelector(
    (state) => state.UpdateDesignation
  );
  const { data: addDesignation } = useAppSelector(
    (state) => state.AddDesignation
  );
  const { data: deleteDesignationData } = useAppSelector(
    (state) => state.DeleteDesignation
  );
  const nav = useNavigate();
  const currentLocation = useLocation();

  const isUpdateable =
    updateableDate && Object.keys(updateableDate).length !== 0;
  const column: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
      maxWidth: 190,
    },
    {
      field: "name",
      renderHeader: () => <b>Name</b>,
      flex: 1,
      type: "string",
      // maxWidth: 250,
    },
    // {
    //   field: "working_time",
    //   renderHeader: () => <b>Working Time</b>,
    //   flex: 2,
    //   type: "string",
    //   valueGetter: (params: GridValueGetterParams) => {
    //     const workingHours = params.row.working_hours;
    //     if (!workingHours) return "-";

    //     const entries = Object.entries(workingHours) as [
    //       string,
    //       { open: boolean; start: string; end: string }
    //     ][];

    //     return entries
    //       .map(([day, time]) => {
    //         const label = day.charAt(0).toUpperCase() + day.slice(1);
    //         return `${label}: ${
    //           time.open ? `Active (${time.start}-${time.end})` : "Deactive"
    //         }`;
    //       })
    //       .join(" | ");
    //   },
    // },

    {
      field: "designation_vehicle_count",
      renderHeader: () => <b>Vehicle Count</b>,
      flex: 1,
      type: "number",
      headerAlign: "center",
      align: "center",
      // maxWidth: 250,
    },

    // {
    //   field: "accepted_vehicle_count",
    //   renderHeader: () => <b>Accept Count</b>,
    //   flex: 1,
    //   type: "number",
    //   headerAlign: "center",
    //   align: "center",
    //   // maxWidth: 250,
    // },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      getActions: (params: GridRowParams<any>) => [
        <GridActionsCellItem
          key="Add"
          label="Add"
          title="Add Vehicle"
          icon={<Add className="action_icons" />}
          onClick={() => {
            console.log(params.row.id);

            dispatch(getMembershipVehicle(params.row.id));
            nav(
              `/location/membershipVehicle/${params.row.id}`,
              { state: { designationName: params.row.name, designationType: params.row.designation_type, parentPath: currentLocation.pathname } }
            );
          }}
        />,
        <GridActionsCellItem
          key="Edit"
          label="Edit"
          icon={<Edit className="action_icons" />}
          onClick={() => {
            dispatch(designationUpdateableData(params.row));
            setOpen(true);
          }}
        />,

        <GridActionsCellItem
          key="Delete"
          label="Delete"
          icon={<Delete className="action_icons" />}
          onClick={() => {
            setDeleteOpen(true);
            setDeleteableName(params.row.name ?? "");
            setDeleteableId(params.row.id!);
          }}
        />,
      ],
      cellClassName: "action_cell",
    },
  ];

  const MemnbershipColumn: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
      maxWidth: 190,
    },
    {
      field: "name",
      renderHeader: () => <b>Name</b>,
      flex: 1,
      type: "string",
      // maxWidth: 250,
    },
    // {
    //   field: "working_time",
    //   renderHeader: () => <b>Working Time</b>,
    //   flex: 2,
    //   type: "string",
    //   valueGetter: (params: GridValueGetterParams) => {
    //     const workingHours = params.row.working_hours;
    //     if (!workingHours) return "-";

    //     const entries = Object.entries(workingHours) as [
    //       string,
    //       { open: boolean; start: string; end: string }
    //     ][];

    //     return entries
    //       .map(([day, time]) => {
    //         const label = day.charAt(0).toUpperCase() + day.slice(1);
    //         return `${label}: ${
    //           time.open ? `Active (${time.start}-${time.end})` : "Deactive"
    //         }`;
    //       })
    //       .join(" | ");
    //   },
    // },

    {
      field: "designation_vehicle_count",
      renderHeader: () => <b>Vehicle Count</b>,
      flex: 1,
      type: "number",
      headerAlign: "center",
      align: "center",
      // maxWidth: 250,
    },

    // {
    //   field: "accepted_vehicle_count",
    //   renderHeader: () => <b>Accept Count</b>,
    //   flex: 1,
    //   type: "number",
    //   headerAlign: "center",
    //   align: "center",
    //   // maxWidth: 250,
    // },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      getActions: (params: GridRowParams<any>) => [
        <GridActionsCellItem
          key="Add"
          label="Add"
          title="Add Vehicle"
          icon={<Add className="action_icons" />}
          onClick={() => {
            console.log(params.row.id);

            dispatch(getMembershipVehicle(params.row.id));
            nav(
              `/location/membershipVehicle/${params.row.id}`,
              { state: { designationName: params.row.name, designationType: params.row.designation_type, parentPath: currentLocation.pathname } }
            );
          }}
        />,
        // <GridActionsCellItem
        //   key="Edit"
        //   label="Edit"
        //   icon={<Edit className="action_icons" />}
        //   onClick={() => {
        //     dispatch(designationUpdateableData(params.row));
        //     setOpen(true);
        //   }}
        // />,

        // <GridActionsCellItem
        //   key="Delete"
        //   label="Delete"
        //   icon={<Delete className="action_icons" />}
        //   onClick={() => {
        //     setDeleteOpen(true);
        //     setDeleteableName(params.row.name ?? "");
        //     setDeleteableId(params.row.id!);
        //   }}
        // />,
      ],
      cellClassName: "action_cell",
    },
  ];

  useEffect(() => {
    // console.log('renderd');

    dispatch(getDesignation(id));
  }, [updateDesignation, addDesignation, deleteDesignationData]);

  useEffect(() => {
    return () => {
      dispatch(clearAddDesignationState());
      dispatch(clearUpdateDesignationState());
      dispatch(clearDeleteDesignation());
    };
  }, []);

  const data1 = data?.response?.data;
  const masterData = Array.isArray(data1)
    ? data1
        .filter((e) => e.designation_type === "OTHERS")
        .map((master, index) => ({
          ...master,
          id: master._id,
          index: index + 1,
        }))
    : [];

  const membershipMasterData = Array.isArray(data1)
    ? data1
        .filter((e) => e.designation_type != "OTHERS")
        .map((master, index) => ({
          ...master,
          id: master._id,
          index: index + 1,
        }))
    : [];

  const designationForm = (data: FormikProps<IDesignationList>) => {
    setFormik(data);
  };

  const pathParts = window.location.pathname.split("/");
  const locationId = pathParts[pathParts.length - 1]; // last part of the path

  return (
    <>
      <div style={{ width: "100%", alignItems: "end" }}>
        <ButtonField
          sx={{
            float: "right",
            width: "250px !important",
            fontSize: "medium !important",
          }}
          className="add_button"
          onClick={() => {
            dispatch(packageManagementCard(locationId));
            nav({
              pathname: `/location/packageManagement/${locationId}`,
            });
          }}>
          Package Management
        </ButtonField>
      </div>

      <div style={{ display: "flex", columnGap: "10px", marginTop: "20px" }}>
        <div style={{ width: "50%" }}>
          <Table
            rows={masterData ?? []}
            columns={column}>
            <CustomToolbar>
              <h6>User Designation</h6>
              <TableSearch />
              <ButtonField
                className="add_button"
                onClick={() => setOpen(true)}>
                <SvgIcon
                  component={Add}
                  inheritViewBox
                />
                Add New
              </ButtonField>
            </CustomToolbar>
          </Table>

          <Dialog
            open={open}
            dialogClassName="master_dialog"
            dialogTitleClassName="master_dialog_title"
            Dialog_Title={
              <>
                {isUpdateable ? "Edit" : "Add New"}
                <IconButtonField onClick={() => setOpen(false)}>
                  <SvgIcon
                    component={Cancel}
                    inheritViewBox
                  />
                </IconButtonField>
              </>
            }
            Dialog_Content={
              <DesignationForm designationForm={designationForm} />
            }
            dialogActionClassName="master_dialog_action"
            Dialog_Actions={
              <>
                <ButtonField
                  className="cancel_button"
                  onClick={() => setOpen(false)}>
                  Cancel
                </ButtonField>
                <ButtonField
                  className="add_button"
                  onClick={() => formik?.handleSubmit()}>
                  {isUpdateable ? "Update" : "Save"}
                </ButtonField>
              </>
            }
          />

          <ResponseDialog
            response={addDesignation}
            parentDialog={setOpen}
          />
          <ResponseDialog
            response={updateDesignation}
            parentDialog={setOpen}
          />

          <DeleteDialog
            deleteableName={deleteableName}
            open={deleteOpen}
            setOpen={setDeleteOpen}
            deleteFunction={() => dispatch(deleteDesignation(deleteableId))}
            response={deleteDesignationData}
          />
        </div>
        <div style={{ width: "50%" }}>
          {/* <Vehicle /> */}
          <Table
            rows={membershipMasterData ?? []}
            columns={MemnbershipColumn}>
            <CustomToolbar>
              <h6>Membership</h6>
              <TableSearch />
              {/* <ButtonField
                className="add_button"
                onClick={() => setOpen(true)}>
                <SvgIcon
                  component={Add}
                  inheritViewBox
                />
                Add New
              </ButtonField> */}
            </CustomToolbar>
          </Table>
        </div>
      </div>
    </>
  );
};

export default Designation;
